export const MONTHS = {
  _1Month: { id: "_1month", name: "1 Month", days: 30 },
  _2Month: { id: "_2month", name: "2 Month", days: 60 },
  _3Month: { id: "_3month", name: "3 Month", days: 90 },
  _6Month: { id: "_6month", name: "6 Month", days: 180 },
  _1YEAR: { id: "_1year", name: "1 Year", days: 365 },
  _2YEAR: { id: "_2year", name: "2 Years", days: 730 },
  _3YEAR: { id: "_3year", name: "3 Years", days: 1095 },
}
